export default __webpack_public_path__ + "static/media/astronaut.03efa84e.png";